module.exports = __webpack_public_path__ + "static/FAVT_banner_mobile.dcf7d8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner_mobile.png
// module id = 990
// module chunks = 101932004231744